/**
 * Axios Scroll Interceptor Plugin
 * Automatically scrolls to top when flash messages are shown
 * This ensures users always see success/error notifications
 */

export default {
    install(Vue) {
        // Store reference to the original flash method
        const originalFlash = Vue.prototype.flash;
        
        // Override the flash method to include automatic scrolling
        Vue.prototype.flash = function(message, type = 'success') {
            // Call original flash method
            if (originalFlash) {
                originalFlash.call(this, message, type);
            } else {
                // Fallback if original doesn't exist
                this.$root.$emit('flash', { message, type });
            }
            
            // Auto-scroll to top with smooth animation
            this.scrollToTop(true);
        };
        
        // Also intercept axios responses globally for common success patterns
        if (Vue.prototype.$http) {
            Vue.prototype.$http.interceptors.response.use(
                response => {
                    // Check for success messages in response data
                    if (response.data && typeof response.data === 'object') {
                        // Common success message patterns
                        if (response.data.message && 
                            (response.data.status === 'success' || 
                             response.data.success === true ||
                             response.data.message.toLowerCase().includes('successfully') ||
                             response.data.message.toLowerCase().includes('saved') ||
                             response.data.message.toLowerCase().includes('created') ||
                             response.data.message.toLowerCase().includes('updated') ||
                             response.data.message.toLowerCase().includes('deleted'))) {
                            
                            // Auto-scroll for success messages
                            setTimeout(() => {
                                if (this && typeof this.scrollToTop === 'function') {
                                    this.scrollToTop(true);
                                }
                            }, 100);
                        }
                    }
                    return response;
                },
                error => {
                    // Auto-scroll for error responses
                    setTimeout(() => {
                        if (this && typeof this.scrollToTop === 'function') {
                            this.scrollToTop(true);
                        }
                    }, 100);
                    return Promise.reject(error);
                }
            );
        }
    }
};